import { useOrganizationCurrencyQuery } from '@/features/settings/organization-currency/queries/useOrganizationCurrencyQuery';
import { CurrencyCell } from './CurrencyCell';

export const OrgCurrencyCell = ({ amount }: { amount: string | undefined }) => {
  const { data: organizationCurrency } = useOrganizationCurrencyQuery();

  return (
    <CurrencyCell
      value={amount !== undefined ? Number(amount) : undefined}
      currencyUnit={organizationCurrency?.currencyCode ?? null}
    />
  );
};
